var _style, _path, _path2, _g, _g2, _path3, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    id: "cover_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1920 1080",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cover_svg__st0{opacity:.23;fill:#dbdbdb}.cover_svg__st1{opacity:.4}.cover_svg__st3{fill:#a0a0a0}.cover_svg__st5{opacity:.4;fill:#9b9b9b}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__curvy-corner-1",
    className: "cover_svg__st0",
    d: "M-1.2,302c20.4-16.9,42.4-29.2,65.4-36.5c31.8-12.8,99.1,40.7,117.5,15.4 c15.4-21.4,58.9-20,88.9-48.5c23-21.7-13.7-86.8,0.4-129.2c9.8-33.4,12.7-68.5,8.5-103H-1.2V302z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__curvy-corner-1-2",
    className: "cover_svg__st0",
    d: "M289.6,1080c-16.3-28.6-28.1-59.5-35.2-91.6c-12.3-44.5,39.2-139,14.9-164.7 C248.6,802,250,741,222.5,699c-20.9-32.2-83.6,19.2-124.5-0.6c-31.2-13.6-65.7-17.7-99.2-11.9V1080H289.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cover_svg__Group_92",
    className: "cover_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Path_13",
    d: "M745,872.7c1.1-0.1,1.9-1.2,1.7-2.2c0-0.2-0.1-0.3-0.1-0.4c-0.8-1.8-2.7-3-4.7-2.7 c-2.9,0.4-5.4,2.5-6.2,5.4c-1.1,3.9,0.1,8,3.1,10.8c3.8,3.4,9.2,4.4,14,2.7c5.8-2.2,9.9-7.3,10.9-13.5c1-7.2-2-14.4-7.8-18.8 c-6.7-5-15.6-6-23.3-2.7c-8.6,3.9-14.5,12.1-15.5,21.5c-0.9,10.5,3.8,20.8,12.4,26.9c9.6,6.6,22,7.6,32.6,2.7 c11.5-5.6,19.1-16.9,20.2-29.6c0.8-13.9-5.6-27.1-17.1-35c-12.6-8.2-28.5-9.2-42-2.7c-14.3,7.3-23.7,21.6-24.9,37.7 c-0.8,17.2,7.5,33.5,21.8,43.1c15.4,9.8,34.9,10.8,51.3,2.7c17.2-9,28.4-26.4,29.5-45.8c0.8-20.5-9.3-39.9-26.4-51.1 c-18.3-11.4-41.3-12.5-60.6-2.7c-19.3,10-33.2,31-34.2,53.8s10.9,46.4,31.1,59.2c20.2,12.8,47.8,14.3,69.9,2.7s37.8-35.9,38.9-61.9 c1-26-12.8-52.8-35.7-67.3c-23-14.5-54.3-15.9-79.3-2.7c-24.9,13.2-42.5,40.7-43.5,70s14.6,59.3,40.4,75.3 c25.8,16.1,60.8,17.5,88.6,2.7s47.1-45.5,48.2-78c1-32.5-16.5-65.7-45.1-83.4c-28.6-17.7-67.3-19.2-97.9-2.7 c-30.6,16.5-51.8,50.3-52.8,86.1s18.3,72.2,49.7,91.5c31.4,19.3,73.8,20.8,107.2,2.7s56.5-55.2,57.5-94.2S836.7,794,802.5,773 c-34.2-21-80.3-22.4-116.6-2.7c-36.2,19.7-61.1,60-62.2,102.3c-1,42.3,22,85.1,59.1,107.7s86.9,24.1,125.9,2.7 s65.8-64.8,66.8-110.4s-23.8-91.5-63.7-115.7s-93.3-25.7-135.2-2.7c-41.9,23-70.4,69.6-71.5,118.4c-1,48.8,25.7,98,68.4,123.8 s99.9,27.3,144.5,2.7s75.1-74.4,76.2-126.5",
    fill: "none",
    stroke: "#a0a0a0",
    strokeWidth: 6.889,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "8.7688,13.7782"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cover_svg__dot-group",
    className: "cover_svg__st1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_4",
    className: "cover_svg__st3",
    cx: 409.6,
    cy: 508.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_5",
    className: "cover_svg__st3",
    cx: 455.6,
    cy: 508.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_6",
    className: "cover_svg__st3",
    cx: 501.5,
    cy: 508.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_7",
    className: "cover_svg__st3",
    cx: 547.4,
    cy: 508.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_8",
    className: "cover_svg__st3",
    cx: 593.4,
    cy: 508.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_9",
    className: "cover_svg__st3",
    cx: 409.6,
    cy: 552,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_10",
    className: "cover_svg__st3",
    cx: 455.6,
    cy: 552,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_11",
    className: "cover_svg__st3",
    cx: 501.5,
    cy: 552,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_12",
    className: "cover_svg__st3",
    cx: 547.4,
    cy: 552,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_13",
    className: "cover_svg__st3",
    cx: 593.4,
    cy: 552,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_14",
    className: "cover_svg__st3",
    cx: 409.6,
    cy: 595.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_15",
    className: "cover_svg__st3",
    cx: 455.6,
    cy: 595.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_16",
    className: "cover_svg__st3",
    cx: 501.5,
    cy: 595.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_17",
    className: "cover_svg__st3",
    cx: 547.4,
    cy: 595.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_18",
    className: "cover_svg__st3",
    cx: 593.4,
    cy: 595.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_19",
    className: "cover_svg__st3",
    cx: 409.6,
    cy: 638.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_20",
    className: "cover_svg__st3",
    cx: 455.6,
    cy: 638.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_21",
    className: "cover_svg__st3",
    cx: 501.5,
    cy: 638.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_22",
    className: "cover_svg__st3",
    cx: 547.4,
    cy: 638.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_23",
    className: "cover_svg__st3",
    cx: 593.4,
    cy: 638.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_24",
    className: "cover_svg__st3",
    cx: 409.6,
    cy: 465.7,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_25",
    className: "cover_svg__st3",
    cx: 455.6,
    cy: 465.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_26",
    className: "cover_svg__st3",
    cx: 501.5,
    cy: 465.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_27",
    className: "cover_svg__st3",
    cx: 547.4,
    cy: 465.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_28",
    className: "cover_svg__st3",
    cx: 593.4,
    cy: 465.1,
    r: 3.9
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__star",
    d: "M376.5,848l21.4,17.2l27.8,3.1l-18.2,21.2l-3.8,27.1l-21.4-17.2l-27.8-3.1l18.2-21.2L376.5,848z",
    opacity: 0.4,
    fill: "#a0a0a0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle",
    className: "cover_svg__st5",
    cx: 1179,
    cy: 944.2,
    r: 12.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle-2",
    className: "cover_svg__st5",
    cx: 106.2,
    cy: 401.5,
    r: 12.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle-3",
    className: "cover_svg__st5",
    cx: 706,
    cy: 132.5,
    r: 12.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle-4",
    className: "cover_svg__st5",
    cx: 855,
    cy: 492.5,
    r: 10.9
  })));
}

export default SvgCover;